export function chargeFooter(state,param) {
    state.charge = param;
}
